const UNAVAILABLE_CHECKIN = 'unavailablecheckin';

Odigeo.Router.handlers.unavailablecheckin = () => {
    $('#page').removeClass().addClass(UNAVAILABLE_CHECKIN);
    Odigeo.Session.set('page', UNAVAILABLE_CHECKIN);
};
